/**
 * Loads the zendesk widget
 */
export function loadScript() {
  return new Promise((resolve, reject) => {
    const snippet = document.getElementById('ze-snippet');

    if (snippet) {
      resolve();

      return;
    }

    const script = document.createElement('script');

    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=617bda50-cab7-4f4d-ad3d-8de2bf058c7c';
    script.id = 'ze-snippet';
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
